/* eslint-disable max-len */
import { CQ_ACTION_CODES } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.legalNSubmit.buttonText]: 'Confirmar pedido',
      [STRING_KEYS.provisionalAgreement.title]: 'Puedes ',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'descargar el resumen del contrato',
      [STRING_KEYS.provisionalAgreement.postTitle]: ' de los nuevos servicios que vas a contratar',
      [STRING_KEYS.waitingPageTexts.initCQ]: 'Preparando tu pedido',
      [STRING_KEYS.waitingPageTexts.extendCQ]: 'Revisando tu configuración de televisión',
      [STRING_KEYS.waitingPageTexts.selectElements]: 'Revisando tu configuración de televisión',
      [STRING_KEYS.waitingPageTexts.getFeatures]: 'Revisando tu configuración de televisión',
      [STRING_KEYS.waitingPageTexts.addToCart]: 'Revisando tu configuración de televisión',
      [STRING_KEYS.waitingPageTexts.getPOTs]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.updateCA]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.getLegalTerms]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.getCQPrices]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.updateCQ]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.getProvisionalAgreement]: 'Configurando oferta',
      [STRING_KEYS.waitingPageTexts.confirmCQ]: 'Enviando contrato y generando pedido',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Suscripciones Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Suscripciones Error TELCO',
      [STRING_KEYS.se.message.shoppingCart.title]: 'DATOS PRODUCTO',
      [STRING_KEYS.summary.staticDirectDebit]: 'El pago de este servicio se realizará en tu factura Movistar',
      [STRING_KEYS.confirmation.subtitle]: 'Tu cambio se hará efectivo en las próximas 24 horas.',
      [STRING_KEYS.summary.title]: 'Casi hemos terminado',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
